import React from "react";
import { NOT_ASSIGNED_TITLE, openCandidateProfile } from "../constants";
import { ExternalLinkIcon } from "../icons";
import { formatActivityDate, stageStatusTone } from "./activityUtils";

const COLUMNS = 7;

const SortableHeader = ({ label, field, sort, onSort }) => {
  const active = sort.field === field;
  return (
    <th className={`activity-th-sortable${active ? " active" : ""}`} onClick={() => onSort(field)}>
      {label}
      {active && (
        <span className="activity-sort-hint">
          {sort.dir === "desc" ? "↓" : "↑"} {sort.dir === "desc" ? "newest" : "oldest"}
        </span>
      )}
    </th>
  );
};

const DateCell = ({ value, missingLabel }) =>
  value ? <span className="activity-date">{formatActivityDate(value)}</span> : <span className="activity-date-missing">{missingLabel}</span>;

const ActivityTable = ({ jobId, rows, loading, sort, onSort, canAccessCandidate, hiringStatusBadge }) => (
  <div className="table-scroll-body">
    <table className="activity-table-v2">
      <thead>
        <tr>
          <th>CANDIDATE</th>
          <th>STAGE</th>
          <SortableHeader label="ASSIGNED" field="assigned" sort={sort} onSort={onSort} />
          <SortableHeader label="COMPLETED" field="completed" sort={sort} onSort={onSort} />
          <th>STAGE STATUS</th>
          <th>HIRING STATUS</th>
          <th className="activity-th-report">REPORT</th>
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <tr>
            <td colSpan={COLUMNS}>
              <div className="table-loading">
                <div className="spinner-border" role="status" style={{ color: "#F75891" }}>
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            </td>
          </tr>
        ) : rows.length === 0 ? (
          <tr>
            <td colSpan={COLUMNS} className="no-data-cell">No stage activity matches these filters</td>
          </tr>
        ) : (
          rows.map((row) => {
            const { candidate } = row;
            const accessible = canAccessCandidate(candidate);
            return (
              <tr key={row.key} className={accessible ? undefined : "row-locked"} title={accessible ? undefined : NOT_ASSIGNED_TITLE}>
                <td>
                  <div className="activity-candidate-name">{candidate.name || "--"}</div>
                  {candidate.phone_number && <div className="activity-candidate-phone">{candidate.phone_number}</div>}
                </td>
                <td className="activity-stage-name">{row.stageName}</td>
                <td><DateCell value={row.assignedAt} missingLabel="Not recorded" /></td>
                <td>
                  {row.completed
                    ? <DateCell value={row.completedAt} missingLabel="Not recorded" />
                    : <span className="activity-dash">—</span>}
                </td>
                <td><span className={`activity-badge tone-${stageStatusTone(row.statusLabel)}`}>{row.statusLabel}</span></td>
                <td>{hiringStatusBadge(row)}</td>
                <td className="activity-td-report">
                  <button
                    type="button"
                    className={`activity-report-link${row.completed ? " is-report" : ""}`}
                    disabled={!accessible}
                    onClick={() => openCandidateProfile(jobId, candidate.id)}
                  >
                    {row.completed ? "View report" : "Open profile"}
                    <ExternalLinkIcon />
                  </button>
                </td>
              </tr>
            );
          })
        )}
      </tbody>
    </table>
  </div>
);

export default ActivityTable;
